export const DotButton = (props: any) => {
  const { selected, onClick } = props;

  return (
    <button aria-label='dot' className={'embla__dot'.concat(selected ? ' embla__dot--selected' : '')} type='button' onClick={onClick} />
  );
};
